import * as Yup from 'yup';
import validLookup from '../../../utils/validLookup';

export const validationSchemaValidOrderServices = Yup.object().shape({
    validServiceData: Yup.array().of(Yup.object().shape({
        name: Yup.string().required('Name is required'),
        cost: Yup.number()
            .typeError('Please enter a valid amount')
            .min(0, 'Amount cannot be negative')
            .required('Cost is required'),
        isTaxable: Yup.boolean(),
        defaultTaxPercentage: Yup.number()
            .typeError('Please enter a valid amount')
            .min(0, 'Tax percentage cannot be negative')
            .max(100, 'Tax percentage must be less than 100%')
    }))
});

export  const validationSchemaValidEncounter = Yup.object().shape({
    validServiceData: Yup.array().of(Yup.object().shape({
        name: Yup.string().required('Name is required'),
        duration: Yup.number()
            .typeError('Please enter a valid duration')
            .min(0, 'Amount cannot be negative')
            .max(500, 'Duration must be less than 500 minutes')
            .required('Cost is required'),
        notes: Yup.string(),
    }))
});

export  const validationSchemaValidTreatment = Yup.object().shape({
    validServiceData: Yup.array().of(Yup.object().shape({
        name: Yup.string().required('Name is required'),
        labCost: Yup.number()
        .typeError('Please enter a valid amount')
        .min(0, 'Amount cannot be negative'),
        listPrice: Yup.number()
        .typeError('Please enter a valid amount')
        .positive('Amount must be positive'),
        notes: Yup.string(),
    }))
});

export const initialValuesEncounter = {
    name: '',
    duration: '',
    notes: '',
    status: validLookup.validStatus.active
};

export const initialValuesTreatment = {
    name: '',
    labCost: '',
    listPrice: '',
    isTaxable: false,
    defaultTaxPercentage: 0,
    notes: '',
    status: validLookup.validStatus.active
};

export const initialValues = {
    name: '',
    isTaxable: false,
    defaultTaxPercentage: 0,
    cost: '',
    status: validLookup.validStatus.active
};

export const validationSchemaValidLensBrand = Yup.object().shape({
    validLensBrandData: Yup.array().of(Yup.object().shape({
        name: Yup.string().required('Name is required'),
    }))
});

export const initialValuesLensBrand = {
    name: '',
    status: validLookup.validStatus.active
};

export const validationSchemaValidLensModel = Yup.object().shape({
    validLensBrandData: Yup.array().of(Yup.object().shape({
        name: Yup.string().required('Name is required'),
    }))
});

export const initialValuesLensModel = {
    name: '',
    status: validLookup.validStatus.active
};

export const validationSchemaValidFrame = Yup.object().shape({
    validLensBrandData: Yup.array().of(Yup.object().shape({
        name: Yup.string().required('Name is required'),
    }))
});

export const initialValuesFrame = {
    name: '',
    status: validLookup.validStatus.active
};